import customFetcher, { type FetcherConfig } from './http';

type OrvalRequest = Parameters<typeof customFetcher>[0];

export default function orvalFetcher<T>(
  request: OrvalRequest,
  config?: FetcherConfig,
): Promise<T> {
  return customFetcher<T>(request, config);
}
